import server_api from "data/server_apis/server_api";

const createAdmin = (data) => {
  const resp = server_api.post("/accounts/user/admin", data);
  return resp;
};

const createCustomer = (data) => {
  const resp = server_api.post("/accounts/user/customer", data);
  return resp;
};

export const createCustomerProfile = (data) => {
  const resp = server_api.post("/accounts/customer", data);
  return resp;
};

const createDistributor = (data) => {
  const resp = server_api.post("/accounts/user/distributor", data);
  return resp;
};

const createFillingPerson = (data) => {
  const resp = server_api.post("/accounts/user/filling_person", data);
  return resp;
};

const createLocationAdmin = (data) => {
  const resp = server_api.post("/accounts/user/location_admin", data);
  return resp;
};

const createMachineAdmin = (data) => {
  const resp = server_api.post("/accounts/user/machine_admin", data);
  return resp;
};

const createVendingMachine = (data) => {
  const resp = server_api.post("/accounts/user/vending_machine", data);
  return resp;
};

const getAdmin = () => {
  const resp = server_api.get("/accounts/user/admin");
  return resp;
};

const getCustomer = () => {
  const resp = server_api.get("/accounts/customer");
  return resp;
};

const getDistributor = () => {
  const resp = server_api.get("/accounts/user/distributor");
  return resp;
};

const getFillingPerson = () => {
  const resp = server_api.get("/accounts/user/filling_person");
  return resp;
};

const getMachineAdmin = () => {
  const resp = server_api.get("/accounts/user/machine_admin");
  return resp;
};

const getLocationAdmin = () => {
  const resp = server_api.get("/accounts/user/location_admin");
  return resp;
};

const getVendingMachine = () => {
  const resp = server_api.get("/accounts/user/vending_machine");
  return resp;
};

const activateUser = (user) => {
  const resp = server_api.get(`/accounts/user/${user}/activate`);
  return resp;
};
const deActivateUser = (user) => {
  const resp = server_api.get(`/accounts/user/${user}/de_activate`);
  return resp;
};

const changePassword = (data) => {
  return server_api.put("/accounts/change-password", data);
};

export {
  createAdmin,
  createCustomer,
  createDistributor,
  createFillingPerson,
  createMachineAdmin,
  createVendingMachine,
  getAdmin,
  getCustomer,
  getDistributor,
  getFillingPerson,
  getMachineAdmin,
  getVendingMachine,
  activateUser,
  deActivateUser,
  createLocationAdmin,
  getLocationAdmin,
  changePassword,
};
